export default __webpack_public_path__ + "static/media/doctor_200x200.b2738d89.png";